import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { getBlogList } from "../services/writerBlog";
import { useNavigate, useParams } from "react-router";
import { CustomAlert, showToastAlert } from "../admin/components/CustomAlert";
import WebsiteBreadCrumb from "./../website/website-components/WebsiteBreadCrumb";
import BlogCard from "./BlogCard";
import Pagination from "@mui/material/Pagination"; // Import MUI Pagination
import Stack from "@mui/material/Stack"; // Import Stack for layout
import { toCamelCaseForFirstChar } from "../services/utilApis";

const BlogList = () => {
  const { categoryname } = useParams();

  const [allBlogs, setAllBlogs] = useState([]);
  const [filteredBlogList, setFilteredBlogList] = useState([]);
  const [categories, setCategories] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = 10;

  useEffect(() => {
    loadData();
  }, [categoryname]);

  const loadData = async () => {
    try {
      const response = await getBlogList();
      if (response.status !== 200) {
        showToastAlert(response?.data?.message, "error");
        return;
      }

      const blogs = response?.data?.blogs || [];
      const categories = response?.data?.categories || [];

      setAllBlogs(blogs);
      setCategories(categories);

      if (categoryname) {
        const filteredBlogs = blogs.filter((blog) =>
          blog.categories.includes(categoryname)
        );
        setFilteredBlogList(filteredBlogs);
      } else {
        setFilteredBlogList(blogs);
      }
    } catch (error) {
      console.error("Error loading blogs", error);
    }
  };

  const handlePageChange = (event, pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo(0, 0);
  };

  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = filteredBlogList.slice(
    indexOfFirstBlog,
    indexOfLastBlog
  );

  const totalPages = Math.ceil(filteredBlogList.length / blogsPerPage);

  return (
    <div>
      <Helmet>
        <title> { categoryname ? `${toCamelCaseForFirstChar(categoryname.replace(/-/g, " "))} -`  : "" } HeyInterns Blog</title>
      </Helmet>
      <WebsiteBreadCrumb
        title="HeyInterns Blog"
        subtitle={ categoryname ? toCamelCaseForFirstChar(categoryname.replace(/-/g, " ")) : "" }
      />

      <div className="blogs-page-wrapper">
        <div className="container py-5">
          {currentBlogs.length === 0 ? (
            <div className="text-center">
              <h4>No blogs found</h4>
            </div>
          ) : (
            <div className="row">
              {currentBlogs.map((blog) => (
                <div className="col-sm-6 mb-4" key={blog._id}>
                  <BlogCard blog={blog} />
                </div>
              ))}
            </div>
          )}
          {currentBlogs.length > 0 && (
            <div className="pagination">
              <Stack spacing={2} alignItems="center">
                <Pagination
                  count={totalPages}
                  page={currentPage}
                  onChange={handlePageChange}
                  color="primary"
                  shape="rounded"
                  siblingCount={1}
                  boundaryCount={1}
                  showFirstButton
                  showLastButton
                />
              </Stack>
            </div>
          )}

          <CustomAlert />
        </div>
      </div>
    </div>
  );
};

export default BlogList;
